import React from "react";
import BlastCampaignPage from "./BlastCampaignPage";
import { BlastCampaignProvider } from "./context";

/**
 * BlastCampaignPage with Provider wrapper
 * This ensures the context is available to all child components
 */
const BlastCampaignPageWithProvider = () => (
  <BlastCampaignProvider>
    <BlastCampaignPage />
  </BlastCampaignProvider>
);

export default BlastCampaignPageWithProvider;
